<template>
  <div v-if="purchase && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="purchase" />
  </div>
</template>
<script>
import Delevery from "@/api/delivery";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    purchase: null,
  }),

  mounted() {
    PrintTemplates.fetchOne("purchase").then(
      function (response) {
        if (response.data.status.isOK()) {
          // console.log(response);
          var formater = response.data.print_template.template;
          this.formater = formater;

          //获取单据详情
          Delevery.print(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.purchase = response.data.purchase;
                if (this.purchase.delivery_info)
                  this.purchase.delivery_info = this.$printUtils.addCitiesName(
                    this.purchase.delivery_info
                  );
                this.purchase.purchase_details =
                  this.purchase.purchase_details.map((detail) => {
                    if (detail.negotiate_price_flg == 1) {
                      // 显示后议价
                      // 单价
                      detail.price = this.$t(
                        "DeliveryDetail.Fields.negotiatePrices"
                      );
                      // 采购金额
                      detail.total = this.$t(
                        "DeliveryDetail.Fields.negotiatePrices"
                      );
                    }
                    return detail;
                  });
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>